import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const LogoutIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M28.292 15.995h-16.25M25.167 12.87l3.125 3.125-3.125 3.125M19.958 11.829V7.87a4.167 4.167 0 0 0-4.166-4.166H7.875A4.167 4.167 0 0 0 3.708 7.87v16.25a4.167 4.167 0 0 0 4.167 4.167h7.917a4.167 4.167 0 0 0 4.166-4.167v-3.958"
    />
  </IconV2>
);

export default LogoutIcon;
